import { useState, useEffect } from 'react';
import { getLocationNamesForCity } from '../data/locations';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Laedt die veroeffentlichten Projekte, die zu einem Ort gehoeren.
 *
 * Beruecksichtigt neben dem Ort selbst auch dessen Ortsteile, damit z.B.
 * ein Projekt aus Lenglern auf der Bovenden-Seite auftaucht.
 *
 * @param {string} citySlug  Slug des Ortes, z.B. 'bovenden'
 * @param {number} limit     maximale Anzahl zurueckgegebener Projekte
 */
export const useLocationProjects = (citySlug, limit = 3) => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const fetchProjects = async () => {
      if (!citySlug) {
        setProjects([]);
        setLoading(false);
        return;
      }

      const relevantNames = getLocationNamesForCity(citySlug).map((n) => n.toLowerCase());

      try {
        // Ohne limit liefert die API nur die 10 neuesten Beitraege - dann
        // faenden die meisten Orte ihre eigenen Projekte nicht.
        const response = await fetch(`${BACKEND_URL}/api/posts?limit=100`);
        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const data = await response.json();
        const posts = data.posts || [];

        const matching = posts
          .filter((post) => {
            const loc = (post.location || '').trim().toLowerCase();
            return loc && relevantNames.includes(loc);
          })
          .slice(0, limit)
          .map((post) => {
            let mainImage = null;
            if (post.images && post.images.length > 0) {
              const url = post.images[0].url;
              mainImage = url.startsWith('http') ? url : `${BACKEND_URL}${url}`;
            }
            return { ...post, mainImage };
          });

        if (!cancelled) setProjects(matching);
      } catch (err) {
        // Projekte sind ergaenzender Inhalt - bei einem Fehler bleibt die
        // Seite ohne diesen Abschnitt bestehen, statt zu brechen.
        if (!cancelled) setProjects([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchProjects();
    return () => { cancelled = true; };
  }, [citySlug, limit]);

  return { projects, loading };
};

export default useLocationProjects;
